import { render } from "./App.vue?vue&type=template&id=446cc25f&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=446cc25f&lang=scss"
import "./App.vue?vue&type=style&index=1&id=446cc25f&lang=css"

import exportComponent from "C:\\Users\\columbus\\Desktop\\git\\speaker-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__